import React, { useState, useEffect } from "react";
import { Modal, Form, Input, Button, message, Select } from "antd";
import "./style.scss";
import { useSelector } from "react-redux";
import OrderService from "../../services/OrderService";

const { Option } = Select;

export default function AddCatering(props) {
  const formRef = React.createRef();
  const [form] = Form.useForm();
  const [delivery, setDelivery] = useState(true);
  const [long, setLong] = useState();
  const adminRestaurant = useSelector((state) => state.admin);

  useEffect(() => {
    if (props.isEdit) {
      formRef.current.setFieldsValue({
        name: props.updatedTestimonial.name,
        email: props.updatedTestimonial.email,
        phone_number: props.updatedTestimonial.phone_number,
        job_title: props.updatedTestimonial.job_title,
        allow_delivery: props.updatedTestimonial.allow_delivery,
      });
      setDelivery(props.updatedTestimonial.allow_delivery);
      setLong(props.updatedTestimonial.long);
    }
  }, [props]);

  const addAdmin = async (values) => {
    const testimonials = {
      restaurant_id: 1,
      start_time: "2022-07-31T09:55:52.125Z",
      end_time: "2022-08-30T09:55:52.125Z",
      time_zone: "Africa/Asmera",
      customer_location_id: 1,
      catering_pickup_date: "2022-07-31T09:55:52.125Z",
    };

    if (props.isEdit) {
      await OrderService.updateCatering(
        testimonials,
        props.updatedTestimonial && props.updatedTestimonial.id
      );
      message.success("Updated Successfully");
    } else {
      await OrderService.addCaterings(testimonials);
      message.success("Added Successfully");
    }

    props.closeModal(false);
  };

  return (
    <Modal
      title={props.isEdit ? "Update Restaurant" : "Add Restaurant"}
      open={props.modalOpen}
      footer={null}
      onCancel={() => props.closeModal(false)}
    >
      <Form ref={formRef} form={form} onFinish={addAdmin} layout="vertical">
        <Form.Item
          name="name"
          label="Employee name"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="email"
          label="Email"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="phone_number"
          label="Phone Number"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="job_title"
          label="Job Title"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="allow_delivery"
          label="Allow delivery"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Select defaultValue={delivery} style={{ width: 120 }}>
            <Option value={true}>true</Option>
            <Option value={false}>false</Option>
          </Select>
        </Form.Item>

        <Form.Item className="button-form">
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
}
